import {Editor} from '@tiptap/react'
import {KTSVG} from '../../../../_metronic/helpers'
import {convertToBase64} from '../../helperFunction/_helper'

interface ToolbarButtonOption {
  iconPath: string
  onClick: () => void
  disabled?: boolean
  className?: string
  iconClass?: string
}

type Props = {
  editor: Editor | null
  isFile: boolean
}

const Menubar = ({editor, isFile}: Props) => {
  if (!editor) return null

  const getClass = (name: string, attrs: Record<string, any> = {}) =>
    editor.isActive(name, attrs) ? 'text-info bg-light' : 'text-muted'

  const options: ToolbarButtonOption[] = [
    {
      iconPath: '/media/icons/duotune/text/txt005.svg',
      onClick: () => editor.chain().focus().toggleBold().run(),
      disabled: !editor.can().chain().focus().toggleBold().run(),
      className: getClass('bold'),
      iconClass: `svg-icon ${getClass('bold')}`,
    },
    {
      iconPath: '/media/icons/duotune/text/txt006.svg',
      onClick: () => editor.chain().focus().toggleItalic().run(),
      disabled: !editor.can().chain().focus().toggleItalic().run(),
      className: getClass('italic'),
      iconClass: `svg-icon ${getClass('italic')}`,
    },
    {
      iconPath: '/media/icons/duotune/text/txt007.svg',
      onClick: () => editor.chain().focus().toggleUnderline().run(),
      disabled: !editor.can().chain().focus().toggleUnderline().run(),
      className: `${editor.isActive('underline') ? 'text-info bg-light' : 'text-muted'}`,
      iconClass: `svg-icon ${editor.isActive('underline') ? 'text-info' : 'text-muted'}`,
    },
    {
      iconPath: '/media/icons/duotune/text/txt008.svg',
      onClick: () => editor.chain().focus().toggleStrike().run(),
      disabled: !editor.can().chain().focus().toggleStrike().run(),
      className: getClass('strike'),
      iconClass: `svg-icon ${getClass('strike')}`,
    },
    {
      iconPath: `/media/icons/duotune/text/p.svg`,
      onClick: () => editor.chain().focus().setParagraph().run(),
      className: getClass('paragraph'),
      iconClass: `svg-icon ${getClass('paragraph')}`,
    },
    {
      iconPath: `/media/icons/duotune/text/h1.svg`,
      onClick: () => editor.chain().focus().toggleHeading({level: 1}).run(),
      className: getClass('heading', {level: 1}),
      iconClass: `svg-icon ${getClass('heading', {level: 1})}`,
    },
    {
      iconPath: `/media/icons/duotune/text/h2.svg`,
      onClick: () => editor.chain().focus().toggleHeading({level: 2}).run(),
      className: getClass('heading', {level: 2}),
      iconClass: `svg-icon ${getClass('heading', {level: 2})}`,
    },
    {
      iconPath: `/media/icons/duotune/text/h3.svg`,
      onClick: () => editor.chain().focus().toggleHeading({level: 3}).run(),
      className: getClass('heading', {level: 3}),
      iconClass: `svg-icon ${getClass('heading', {level: 3})}`,
    },
    {
      iconPath: `/media/icons/duotune/text/h4.svg`,
      onClick: () => editor.chain().focus().toggleHeading({level: 4}).run(),
      className: getClass('heading', {level: 4}),
      iconClass: `svg-icon ${getClass('heading', {level: 4})}`,
    },
    {
      iconPath: '/media/icons/duotune/text/txt009.svg',
      onClick: () => editor.chain().focus().toggleBulletList().run(),
      className: getClass('bulletList'),
      iconClass: `svg-icon ${getClass('bulletList')}`,
    },
    {
      iconPath: '/media/icons/duotune/text/txt010.svg',
      onClick: () => editor.chain().focus().toggleOrderedList().run(),
      className: getClass('orderedList'),
      iconClass: `svg-icon ${getClass('orderedList')}`,
    },
    {
      iconPath: '/media/icons/duotune/text/txt001.svg',
      onClick: () => editor.chain().focus().setTextAlign('left').run(),
      className: `${editor.isActive({textAlign: 'left'}) ? 'text-info bg-light' : 'text-muted'}`,
      iconClass: `svg-icon ${editor.isActive({textAlign: 'left'}) ? 'text-info' : 'text-muted'}`,
    },
    {
      iconPath: '/media/icons/duotune/text/txt002.svg',
      onClick: () => editor.chain().focus().setTextAlign('center').run(),
      className: `${editor.isActive({textAlign: 'center'}) ? 'text-info bg-light' : 'text-muted'}`,
      iconClass: `svg-icon ${editor.isActive({textAlign: 'center'}) ? 'text-info' : 'text-muted'}`,
    },
    {
      iconPath: '/media/icons/duotune/text/txt003.svg',
      onClick: () => editor.chain().focus().setTextAlign('right').run(),
      className: `${editor.isActive({textAlign: 'right'}) ? 'text-info bg-light' : 'text-muted'}`,
      iconClass: `svg-icon ${editor.isActive({textAlign: 'right'}) ? 'text-info' : 'text-muted'}`,
    },
    // {
    //   iconPath: '/media/icons/duotune/text/attachement-add.svg',
    //   onClick: () => {
    //     const input = document.createElement('input')
    //     input.type = 'file'
    //     input.accept = 'image/*'
    //     input.onchange = async () => {
    //       const file = input.files?.[0]
    //       if (file) {
    //         const base64 = await convertToBase64(file)
    //         editor
    //           .chain()
    //           .focus()
    //           .insertContent({
    //             type: 'image',
    //             attrs: {
    //               src: base64,
    //               class: 'w-50',
    //             },
    //           })
    //           .run()
    //       }
    //     }
    //     input.click()
    //   },
    //   className: 'text-muted',
    //   iconClass: 'svg-icon text-muted',
    // },
  ]

  if (isFile) {
    options.push({
      iconPath: '/media/icons/duotune/text/attachement-add.svg',
      onClick: () => {
        const input = document.createElement('input')
        input.type = 'file'
        input.accept = 'image/*'
        input.onchange = async () => {
          const file = input.files?.[0]
          if (file) {
            const base64 = await convertToBase64(file)
            editor
              .chain()
              .focus()
              .insertContent({
                type: 'image',
                attrs: {
                  src: base64,
                  class: 'w-50',
                },
              })
              .run()
          }
        }
        input.click()
      },
      className: 'text-muted',
      iconClass: 'svg-icon text-muted',
    })
  }

  return (
    <div className='mt-3 custom-input p-2'>
      <div className='d-flex gap-2 flex-wrap'>
        {options.map((btn, i) => (
          <button
            key={i}
            type='button'
            onClick={btn.onClick}
            disabled={btn.disabled}
            className={btn.className}
            style={{
              width: '30px',
              height: '30px',
              outline: 0,
              border: 0,
              backgroundColor: 'transparent',
            }}
          >
            <KTSVG path={btn.iconPath} className={btn.iconClass} />
          </button>
        ))}
      </div>
    </div>
  )
}

export default Menubar
